import React from 'react'
import { Link } from 'react-router-dom'
import Logo from '@/components/UI/Logo'

/**
 * Footer - Site footer with links and company information
 * 
 * @component
 */
const Footer = () => {
  const currentYear = new Date().getFullYear()

  const footerSections = [
    {
      title: 'Shop',
      links: [
        { name: 'All Products', path: '/products' },
        { name: 'Categories', path: '/categories' },
        { name: 'Featured', path: '/products?featured=true' },
      ]
    }
  ]

  const legalLinks = [
    { name: 'Privacy Policy', path: '/privacy' },
    { name: 'Terms of Service', path: '/terms' },
    { name: 'About Us', path: '/about' },
  ]


  return (
    <footer className="relative overflow-hidden">
      {/* Exact Mauritius Flag Background */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 w-full h-1/4 bg-red-600"></div>
        <div className="absolute top-1/4 left-0 w-full h-1/4 bg-blue-800"></div>
        <div className="absolute top-2/4 left-0 w-full h-1/4 bg-yellow-500"></div>
        <div className="absolute bottom-0 left-0 w-full h-1/4 bg-green-600"></div>
      </div>

      <div className="container-custom relative z-10">
        {/* Red Section - Header Style Logo and Brand */}
        <div className="h-16 flex items-center justify-center">
          <Logo 
            size="lg" 
            showText={true} 
            textSize="lg"
            className="hover:scale-105 transition-transform duration-300"
          />
        </div>

        {/* Blue Section - Header Style Navigation Tabs */}
        <div className="h-16 flex items-center justify-center">
          <nav className="flex items-center justify-center gap-6 sm:gap-8 lg:gap-12">
            {footerSections.map((section) => (
              <div key={section.title} className="flex items-center space-x-4">
                <h4 className="font-bold text-sm sm:text-base text-white drop-shadow-lg uppercase">
                  {section.title}
                </h4>
                <div className="flex items-center gap-3">
                  {section.links.map((link) => (
                    <Link
                      key={link.name}
                      to={link.path}
                      className="text-white hover:text-yellow-300 transition-all duration-300 text-xs sm:text-sm hover:scale-105 transform font-medium px-2 py-1 rounded hover:bg-white/10"
                    >
                      {link.name}
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </nav>
        </div>

        {/* Yellow Section - Legal Links */}
        <div className="h-16 flex items-center justify-center">
          <nav className="flex items-center justify-center gap-6 sm:gap-8 lg:gap-12">
            {legalLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className="text-white hover:text-yellow-300 transition-all duration-300 text-sm sm:text-base hover:scale-105 transform font-medium px-3 py-2 rounded hover:bg-white/10"
              >
                {link.name}
              </Link>
            ))}
          </nav>
        </div>

        {/* Green Section - Header Style Copyright and Origin */}
        <div className="h-16 flex items-center justify-center">
          <div className="flex items-center space-x-6">
            <p className="text-sm sm:text-base text-white font-medium drop-shadow-lg">
              &copy; {currentYear} Mauritian Groceries. All rights reserved.
            </p>
            <div className="flex items-center space-x-2">
              <span className="text-lg">🌍</span>
              <span className="text-sm sm:text-base text-white font-medium drop-shadow-lg">Made in Mauritius</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
